/* KKO³ — Option cadeau (emballage + carte manuscrite, CHF 5.–, niveau commande).
   La case ajoute/retire le produit « Emballage cadeau » ; le message est stocké en attribut de panier.
   Affiche un avertissement quand la case est cochée : toute la commande part dans le cadeau,
   livrée chez la personne qui le reçoit. Texte modifiable ci-dessous (NOTICE_TITLE / NOTICE_TEXT).
   Nettoie aussi les entités HTML visibles dans l'exemple du champ message (ex. &nbsp;). */
(function(){
  if (window.__kkoGiftBound) return;
  window.__kkoGiftBound = true;

  var ATTR_MSG = 'Message carte';
  var NOTICE_TITLE = 'Bon à savoir';
  var NOTICE_TEXT = 'Toute la commande part dans le paquet cadeau, livré directement chez la personne qui le reçoit : indique son adresse au moment du paiement. Des produits pour toi ? Passe-les dans une commande séparée.';
  var saveTimer = null;
  var busy = false;

  function injectStyle(){
    if (document.getElementById('kko-gift-notice-style')) return;
    var st = document.createElement('style');
    st.id = 'kko-gift-notice-style';
    st.textContent =
      '.kko-gift__notice{margin:14px 0 16px;padding:12px 14px;background:#f6efe9;border-left:3px solid #C24A2E;color:#382B23;font-size:13.5px;line-height:1.5;text-align:left;}' +
      '.kko-gift__notice strong{display:block;margin-bottom:3px;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#C24A2E;}' +
      '[data-kko-gift]:not(.is-open) .kko-gift__notice{display:none;}';
    document.head.appendChild(st);
  }

  function ensureNotice(block){
    if (!block || block.querySelector('.kko-gift__notice')) return;
    var ta = block.querySelector('[data-kko-gift-msg]');
    var p = document.createElement('p');
    p.className = 'kko-gift__notice';
    p.setAttribute('role', 'note');
    var t = document.createElement('strong');
    t.textContent = NOTICE_TITLE;
    p.appendChild(t);
    p.appendChild(document.createTextNode(NOTICE_TEXT));
    if (ta){
      var node = ta;
      while (node.parentElement && node.parentElement !== block) node = node.parentElement;
      if (node.parentElement === block){ block.insertBefore(p, node); return; }
    }
    block.appendChild(p);
  }

  function getVariantId(){
    var el = document.querySelector('[data-kko-gift-variant]');
    return el ? el.getAttribute('data-kko-gift-variant') : null;
  }

  function fetchCart(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); });
  }

  function saveMessage(msg){
    var attrs = {};
    attrs[ATTR_MSG] = msg || '';
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function(){});
  }

  function giftLine(cart, variantId){
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++){
      if (String(items[i].variant_id) === String(variantId)) return i + 1;
    }
    return 0;
  }

  function refreshUI(cart){
    if (document.querySelector('.drawer--cart')){
      document.documentElement.dispatchEvent(new CustomEvent('wetheme-toggle-right-drawer', {
        detail: { type: 'cart', forceOpen: true, params: { cart: cart } }
      }));
    } else {
      window.location.reload();
    }
  }

  function addGift(msg){
    var variantId = getVariantId();
    if (!variantId || busy) return;
    busy = true;
    saveMessage(msg)
      .then(function(){
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
      })
      .then(function(){ return fetchCart(); })
      .then(function(cart){ busy = false; refreshUI(cart); })
      .catch(function(){ busy = false; });
  }

  function removeGift(){
    var variantId = getVariantId();
    if (!variantId || busy) return;
    busy = true;
    fetchCart()
      .then(function(cart){
        var line = giftLine(cart, variantId);
        if (!line) return cart;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function(r){ return r.json(); });
      })
      .then(function(){ return saveMessage(''); })
      .then(function(){ return fetchCart(); })
      .then(function(cart){ busy = false; refreshUI(cart); })
      .catch(function(){ busy = false; });
  }

  function cleanPlaceholder(ta){
    if (!ta || !ta.placeholder) return;
    var p = ta.placeholder;
    if (p.indexOf('&') === -1) return;
    ta.placeholder = p.replace(/&nbsp;/g, '\u00a0').replace(/&rsquo;/g, '\u2019').replace(/&amp;/g, '&');
  }

  function prepare(block){
    injectStyle();
    ensureNotice(block);
    cleanPlaceholder(block.querySelector('[data-kko-gift-msg]'));
  }

  function syncBlock(block, on, msg){
    var check = block.querySelector('[data-kko-gift-check]');
    var ta = block.querySelector('[data-kko-gift-msg]');
    var count = block.querySelector('[data-kko-gift-count]');
    prepare(block);
    if (check) check.checked = on;
    block.classList.toggle('is-open', on);
    if (ta && document.activeElement !== ta) ta.value = msg || '';
    if (count && ta) count.textContent = (ta.value || '').length;
  }

  function hydrate(){
    var blocks = document.querySelectorAll('[data-kko-gift]');
    if (!blocks.length) return;
    blocks.forEach(prepare);
    var variantId = getVariantId();
    fetchCart().then(function(cart){
      var on = giftLine(cart, variantId) > 0;
      var attrs = cart.attributes || {};
      var msg = attrs[ATTR_MSG] || '';
      blocks.forEach(function(b){ syncBlock(b, on, msg); });
    }).catch(function(){});
  }

  document.addEventListener('change', function(e){
    var check = e.target.closest && e.target.closest('[data-kko-gift-check]');
    if (!check) return;
    var block = check.closest('[data-kko-gift]');
    var ta = block && block.querySelector('[data-kko-gift-msg]');
    var msg = ta ? ta.value : '';
    document.querySelectorAll('[data-kko-gift]').forEach(function(b){
      prepare(b);
      b.classList.toggle('is-open', check.checked);
    });
    if (check.checked) addGift(msg); else removeGift();
  });

  document.addEventListener('input', function(e){
    var ta = e.target.closest && e.target.closest('[data-kko-gift-msg]');
    if (!ta) return;
    var block = ta.closest('[data-kko-gift]');
    var count = block && block.querySelector('[data-kko-gift-count]');
    if (count) count.textContent = (ta.value || '').length;
    var check = block && block.querySelector('[data-kko-gift-check]');
    if (check && check.checked){
      if (saveTimer) clearTimeout(saveTimer);
      saveTimer = setTimeout(function(){ saveMessage(ta.value); }, 500);
    }
  });

  var mo = new MutationObserver(function(muts){
    for (var i = 0; i < muts.length; i++){
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++){
        var n = added[j];
        if (n.nodeType === 1 && ((n.matches && n.matches('[data-kko-gift]')) || (n.querySelector && n.querySelector('[data-kko-gift]')))){
          hydrate();
          return;
        }
      }
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  document.documentElement.addEventListener('wetheme-toggle-right-drawer', function(){
    setTimeout(hydrate, 350);
  });

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
